import React from "react";
import styles from "./TypeSelection.module.scss";
const activeButton = { type: "workspaces", text: "Workspaces" };
const disabledBuildingTypes = [
  { type: "venues", text: "Venues" },
  { type: "healthcare", supported: false, text: "Healthcare" },
];

function TypeSelection({ onSelect }) {
  return (
    <>
      <div id={styles.typeSelectionContainer}>
        <div id={styles.blurEffect}></div>
        <h5 className={styles.chooseType}>
          Choose an Industry vertical to get started
        </h5>
        <div id={styles.buildingTypesContainer}>
          <div id={styles.buildingTypes}>
            <button
              key={activeButton.type}
              className={`${styles.typeButton} ${styles.supported}`}
              onClick={onSelect}
              data-type={activeButton.type}
              data-supported={"1"}
            >
              <span className={styles.primaryText}>{activeButton.text}</span>
            </button>

            <div>
              <h6>Coming soon</h6>
              <div className={styles.disabledButtonsContainer}>
                {disabledBuildingTypes.map((typeInfo) => (
                  <button
                    key={typeInfo.type}
                    className={styles.typeButton}
                    onClick={onSelect}
                    data-type={typeInfo.type}
                    data-supported={"0"}
                    disabled={true}
                  >
                    <span className={styles.primaryText}>{typeInfo.text}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.sampleContainer}>
          <p>
            <strong>Don't have a map?</strong> Experience it using our sample
            maps instead.
          </p>
        </div>
        <div id={styles.leftGradient} className={styles.gradient}></div>
        <div id={styles.rightGradient} className={styles.gradient}></div>
      </div>
    </>
  );
}

export default TypeSelection;
